import { AgricultureRounded, GridViewRounded } from '@mui/icons-material';
import { Alert, Box, Chip, Paper, Skeleton, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from 'react';

const formatNumber = (value, maximumFractionDigits = 0) =>
    Number(value ?? 0).toLocaleString('hu-HU', { maximumFractionDigits });

const NationalInsuredAreaSummary = ({ area, meparCount, year, plants, loading, hasError }) => {
    if (hasError) {
        return (
            <Alert severity="error" variant="outlined">
                A szűrt terület nem kérdezhető le.
            </Alert>
        );
    }

    return (
        <Paper
            variant="outlined"
            sx={(theme) => ({
                p: 2,
                borderLeft: `4px solid ${theme.palette.primary.main}`,
                backgroundColor: alpha(theme.palette.primary.main, 0.04),
            })}
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
                <Stack direction="row" alignItems="center" gap={1}>
                    <AgricultureRounded color="primary" fontSize="small" />
                    <Typography
                        variant="body2"
                        sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}
                    >
                        Biztosított terület
                    </Typography>
                </Stack>
                <Chip
                    label={`Országos · ${year}`}
                    size="small"
                    color="primary"
                    variant="outlined"
                />
            </Stack>

            <Box sx={{ mt: 1.5 }}>
                {loading ? (
                    <Skeleton variant="text" width="60%" sx={{ fontSize: 32 }} />
                ) : (
                    <Typography
                        component="p"
                        variant="h3"
                        color="primary"
                        sx={{ lineHeight: 1.1, fontVariantNumeric: 'tabular-nums' }}
                    >
                        {formatNumber(area, 2)}
                        <Typography
                            component="span"
                            variant="h5"
                            color="text.secondary"
                            sx={{ ml: 0.75 }}
                        >
                            ha
                        </Typography>
                    </Typography>
                )}
            </Box>

            <Stack direction="row" alignItems="center" gap={0.75} sx={{ mt: 1 }}>
                <GridViewRounded fontSize="inherit" sx={{ color: 'text.secondary' }} />
                {loading ? (
                    <Skeleton variant="text" width={120} />
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        <strong>{formatNumber(meparCount)}</strong> érintett MePAR blokk
                    </Typography>
                )}
            </Stack>

            {plants.length > 0 && (
                <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mt: 1.5 }}>
                    {plants.map((plant) => (
                        <Chip
                            key={plant.id ?? plant.plantCode}
                            label={`${plant.plantName} (${plant.plantCode})`}
                            size="small"
                        />
                    ))}
                </Stack>
            )}

            <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 1.5 }}>
                A kiválasztott növényekhez tartozó biztosított területek országos összege.
            </Typography>
        </Paper>
    );
};

export default NationalInsuredAreaSummary;
